module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/chapters/chapters.component.css
// module id = ./src/app/chapters/chapters.component.css
// module chunks = main